export default __webpack_public_path__ + "static/media/roboto-v20-latin-900.2d00e856.ttf";